import React, { useState, useEffect } from 'react';
import { translate } from '../Services/translation';

export default function Blog(props) {
  const { items } = props;
  const [itemsToShow, setItemsToShow] = useState(items);
  const [categories, setCategories] = useState({});
  const [selected, setSelected] = useState('');

  useEffect(() => {
    var allCategories = [];
    items.forEach((item) => {
      item.Categories.forEach((category) => {
        if (allCategories.indexOf(category) === -1) {
          allCategories.push(category);
        }
      });
    });

    allCategories.sort((a, b) => a.localeCompare(b));

    setCategories(allCategories);
  }, []);

  const changeSelected = (item) => {
    setSelected(item);
    var newItems = items;
    if (item != '') {
      newItems = items.filter((x) => x.Categories.includes(item));
    }
    setItemsToShow(newItems);
  };

  return (
    <div className="blog-page__blog-component">
      <div className="blog-page__categories-container columns">
        <ul className="custom-scroll-mobile">
          <li>
            <button
              onClick={() => changeSelected('')}
              className={
                selected == '' ? 'selected small-button' : 'small-button'
              }
            >
              {translate('blog.all')}
            </button>
          </li>
          {categories.length > 0 &&
            categories.map((item, index) => (
              <li key={index + item}>
                <button
                  onClick={() => changeSelected(item)}
                  className={
                    selected == item ? 'selected small-button' : 'small-button'
                  }
                >
                  {item}
                </button>
              </li>
            ))}
        </ul>
      </div>
      <div className="blog-page__item-container">
        <div className="blog-page__row">
          {itemsToShow.length > 0 &&
            itemsToShow.map((item, index) => (
              <div
                key={index + item.Title}
                className="blog-page__item-wrapper large-4 small-12 columns"
              >
                <div
                  className="blog-page__item"
                  style={{ background: 'url(' + item.ImageUrl + ')' }}
                >
                  <div className="blog-page__text-container">
                    <a className="title-2" href={item.Url}>
                      {item.Title}
                      <div className="small-button">
                        {translate('blog.readmore')}
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            ))}
        </div>
      </div>
    </div>
  );
}
